import { Component, Input, OnChanges, Output, OnInit, EventEmitter } from '@angular/core';
import { Room, User, CLUSTERS, ROLES } from '../../../shared';

@Component({
  selector: 'app-available-rooms',
  templateUrl: 'available-rooms.component.html'
})
export class AvailableRoomsComponent {
  @Input() 
  availableRooms: Room[];
  @Input()
  currentClusterName: string;
  @Input()
  user: User;
  @Output()
  roomPicked: EventEmitter<Room> = new EventEmitter()

  constructor() {
  }

  onRoomPick(room: Room) {
    this.roomPicked.emit(room);
  }

  public isAllowedToBook(): boolean {
    return this.user.role === ROLES.STUDENT.TEAM_LEADER
          || this.user.role === ROLES.TEACHER
          || this.currentClusterName === CLUSTERS.VA.DARK;
  }
}


// WEBPACK FOOTER //
// ./src/app/hunt/components/available-rooms/available-rooms.component.ts